import type * as Types from '../../../../graphql';

import { gql } from '@apollo/client';
import { PlaybookEventBasicsFragmentDoc, PlaybookEventTileFragmentDoc, EventResourcesFragmentDoc } from './event-fragments.gql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetPlaybookEventRelatedSamplesCountsQueryVariables = Types.Exact<{
  eventId: Types.Scalars['Long']['input'];
}>;


export type GetPlaybookEventRelatedSamplesCountsQuery = { playbook: { event: { displayedSampleCount: number | null, totalSampleCount: number | null } | null } | null };

export type GetPlaybookEventSettingsCardQueryVariables = Types.Exact<{
  eventId: Types.Scalars['Long']['input'];
}>;


export type GetPlaybookEventSettingsCardQuery = { playbook: { event: { id: number, alias: string | null, status: string, note: string | null, created: string, supportsLogFileDownload: boolean | null, projectVisibleForUser: boolean | null, eventExpired: boolean | null, executionLogsAvailable: boolean | null, workflowName: string | null, project: { id: number, name: string, color: string | null } | null, owner: { firstName: string | null, lastName: string | null, username: string | null }, job: { id: number, name: string, status: Types.JobStatusEnum | null, created: string | null, tool: string | null, owner: { display: string | null, id: number, username: string | null, firstName: string | null, lastName: string | null, email: string | null } | null, params: { blast: { blastType: string | null } | null } | null } | null, inputs: Array<{ inputValues: Array<string | null> | null, label: string }> | null, workflowP2ExtendedConfig: { sampleType: { name: string } | null } | null, playbook: { id: number, name: string, nameSuffix: string | null, protectedPlaybook: boolean | null, description: string | null, standard: boolean | null, enabled: boolean | null, config: { icon: string | null } | null, type: { id: number | null, class: string | null }, categories: Array<{ name: string }> } } | null } | null };

export type GetPlaybookEventStatusCardQueryVariables = Types.Exact<{
  organismId: Types.Scalars['Long']['input'];
}>;


export type GetPlaybookEventStatusCardQuery = { organism: { playbookEvents: Array<{ id: number, alias: string | null, note: string | null, status: string, created: string, shortSummary: string | null, playbook: { id: number, name: string, nameSuffix: string | null, protectedPlaybook: boolean | null, standard: boolean | null, type: { id: number | null, name: string | null, class: string | null }, config: { icon: string | null } | null }, owner: { id: number, username: string | null, firstName: string | null, lastName: string | null, email: string | null, display: string | null }, project: { id: number, name: string, description: string | null, color: string | null } | null, job: { tool: string | null } | null, results: Array<{ resourceType: string | null, file: { fileName: string | null } | null } | null> | null } | null> | null } };

export type GetPlaybookEventInputCardQueryVariables = Types.Exact<{
  eventId: Types.Scalars['Long']['input'];
}>;


export type GetPlaybookEventInputCardQuery = { playbook: { event: { inputs: Array<{ id: number | null, label: string, workflowField: string | null, resources: Array<{ activity: string | null, direction: string | null, resourceType: string | null, file: { id: number, fileName: string | null, fileBrowseType: string, url: string | null, previewable: boolean, humanReadablePath: string | null, fullPath: string | null, description: string | null, created: string | null, lastModified: string | null, deleted: boolean, hidden: boolean, indexingStatus: Types.IndexStatus | null, typeDisplayName: string | null, creator: { id: number, username: string | null, firstName: string | null, lastName: string | null, email: string | null, display: string | null } | null, lastModifier: { id: number, username: string | null, firstName: string | null, lastName: string | null, email: string | null, display: string | null } | null, project: { id: number, name: string, color: string | null } | null } | null, folder: { path: string | null, humanReadablePath: string | null, deleted: boolean | null, hidden: boolean | null } | null, region: { contig: { id: number, sequenceId: string, organism: { id: number, name: string | null, species: { id: number, name: string } | null } } | null, range: { start: number, stop: number } | null } | null, organism: { id: number, name: string | null, type: string | null, description: string | null, hidden: boolean, species: { name: string } | null } | null } | null> | null }> | null } | null } | null };

export type GetPlaybookEventOutputsCardQueryVariables = Types.Exact<{
  eventId: Types.Scalars['Long']['input'];
}>;


export type GetPlaybookEventOutputsCardQuery = { playbook: { event: { results: Array<{ activity: string | null, direction: string | null, resourceType: string | null, file: { id: number, fileName: string | null, fileBrowseType: string, url: string | null, previewable: boolean, humanReadablePath: string | null, fullPath: string | null, description: string | null, created: string | null, lastModified: string | null, deleted: boolean, hidden: boolean, indexingStatus: Types.IndexStatus | null, typeDisplayName: string | null, creator: { id: number, username: string | null, firstName: string | null, lastName: string | null, email: string | null, display: string | null } | null, lastModifier: { id: number, username: string | null, firstName: string | null, lastName: string | null, email: string | null, display: string | null } | null, project: { id: number, name: string, color: string | null } | null } | null, folder: { path: string | null, humanReadablePath: string | null, deleted: boolean | null, hidden: boolean | null } | null, region: { contig: { id: number, sequenceId: string, organism: { id: number, name: string | null, species: { id: number, name: string } | null } } | null, range: { start: number, stop: number } | null } | null, organism: { id: number, name: string | null, type: string | null, description: string | null, hidden: boolean, species: { name: string } | null } | null } | null> | null } | null } | null };

export type GetPlaybookEventErrorsCardQueryVariables = Types.Exact<{
  eventId: Types.Scalars['Long']['input'];
}>;


export type GetPlaybookEventErrorsCardQuery = { playbook: { event: { getErrors: Array<string | null> | null } | null } | null };

export type GetPlaybookEventEditableFieldsQueryVariables = Types.Exact<{
  eventId: Types.Scalars['Long']['input'];
}>;


export type GetPlaybookEventEditableFieldsQuery = { playbook: { event: { id: number, alias: string | null, note: string | null, owner: { username: string | null } } | null } | null };

export type UpdatePlaybookEventGridOnStatusChangeQueryVariables = Types.Exact<{
  eventId: Types.Scalars['Long']['input'];
}>;


export type UpdatePlaybookEventGridOnStatusChangeQuery = { playbook: { event: { id: number, status: string, results: Array<{ resourceType: string | null } | null> | null } | null } | null };


export const GetPlaybookEventRelatedSamplesCountsDocument = gql`
    query getPlaybookEventRelatedSamplesCounts($eventId: Long!) {
  playbook {
    event(eventId: $eventId) {
      displayedSampleCount
      totalSampleCount
    }
  }
}
    `;

/**
 * __useGetPlaybookEventRelatedSamplesCountsQuery__
 *
 * To run a query within a React component, call `useGetPlaybookEventRelatedSamplesCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaybookEventRelatedSamplesCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaybookEventRelatedSamplesCountsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetPlaybookEventRelatedSamplesCountsQuery(baseOptions: Apollo.QueryHookOptions<GetPlaybookEventRelatedSamplesCountsQuery, GetPlaybookEventRelatedSamplesCountsQueryVariables> & ({ variables: GetPlaybookEventRelatedSamplesCountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlaybookEventRelatedSamplesCountsQuery, GetPlaybookEventRelatedSamplesCountsQueryVariables>(GetPlaybookEventRelatedSamplesCountsDocument, options);
      }
export function useGetPlaybookEventRelatedSamplesCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlaybookEventRelatedSamplesCountsQuery, GetPlaybookEventRelatedSamplesCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlaybookEventRelatedSamplesCountsQuery, GetPlaybookEventRelatedSamplesCountsQueryVariables>(GetPlaybookEventRelatedSamplesCountsDocument, options);
        }
export function useGetPlaybookEventRelatedSamplesCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlaybookEventRelatedSamplesCountsQuery, GetPlaybookEventRelatedSamplesCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlaybookEventRelatedSamplesCountsQuery, GetPlaybookEventRelatedSamplesCountsQueryVariables>(GetPlaybookEventRelatedSamplesCountsDocument, options);
        }
export type GetPlaybookEventRelatedSamplesCountsQueryHookResult = ReturnType<typeof useGetPlaybookEventRelatedSamplesCountsQuery>;
export type GetPlaybookEventRelatedSamplesCountsLazyQueryHookResult = ReturnType<typeof useGetPlaybookEventRelatedSamplesCountsLazyQuery>;
export type GetPlaybookEventRelatedSamplesCountsSuspenseQueryHookResult = ReturnType<typeof useGetPlaybookEventRelatedSamplesCountsSuspenseQuery>;
export type GetPlaybookEventRelatedSamplesCountsQueryResult = Apollo.QueryResult<GetPlaybookEventRelatedSamplesCountsQuery, GetPlaybookEventRelatedSamplesCountsQueryVariables>;
export const GetPlaybookEventSettingsCardDocument = gql`
    query getPlaybookEventSettingsCard($eventId: Long!) {
  playbook {
    event(eventId: $eventId) {
      ...PlaybookEventBasics
    }
  }
}
    ${PlaybookEventBasicsFragmentDoc}`;

/**
 * __useGetPlaybookEventSettingsCardQuery__
 *
 * To run a query within a React component, call `useGetPlaybookEventSettingsCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaybookEventSettingsCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaybookEventSettingsCardQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetPlaybookEventSettingsCardQuery(baseOptions: Apollo.QueryHookOptions<GetPlaybookEventSettingsCardQuery, GetPlaybookEventSettingsCardQueryVariables> & ({ variables: GetPlaybookEventSettingsCardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlaybookEventSettingsCardQuery, GetPlaybookEventSettingsCardQueryVariables>(GetPlaybookEventSettingsCardDocument, options);
      }
export function useGetPlaybookEventSettingsCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlaybookEventSettingsCardQuery, GetPlaybookEventSettingsCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlaybookEventSettingsCardQuery, GetPlaybookEventSettingsCardQueryVariables>(GetPlaybookEventSettingsCardDocument, options);
        }
export function useGetPlaybookEventSettingsCardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlaybookEventSettingsCardQuery, GetPlaybookEventSettingsCardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlaybookEventSettingsCardQuery, GetPlaybookEventSettingsCardQueryVariables>(GetPlaybookEventSettingsCardDocument, options);
        }
export type GetPlaybookEventSettingsCardQueryHookResult = ReturnType<typeof useGetPlaybookEventSettingsCardQuery>;
export type GetPlaybookEventSettingsCardLazyQueryHookResult = ReturnType<typeof useGetPlaybookEventSettingsCardLazyQuery>;
export type GetPlaybookEventSettingsCardSuspenseQueryHookResult = ReturnType<typeof useGetPlaybookEventSettingsCardSuspenseQuery>;
export type GetPlaybookEventSettingsCardQueryResult = Apollo.QueryResult<GetPlaybookEventSettingsCardQuery, GetPlaybookEventSettingsCardQueryVariables>;
export const GetPlaybookEventStatusCardDocument = gql`
    query getPlaybookEventStatusCard($organismId: Long!) {
  organism(organismId: $organismId) {
    playbookEvents {
      ...PlaybookEventTile
    }
  }
}
    ${PlaybookEventTileFragmentDoc}`;

/**
 * __useGetPlaybookEventStatusCardQuery__
 *
 * To run a query within a React component, call `useGetPlaybookEventStatusCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaybookEventStatusCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaybookEventStatusCardQuery({
 *   variables: {
 *      organismId: // value for 'organismId'
 *   },
 * });
 */
export function useGetPlaybookEventStatusCardQuery(baseOptions: Apollo.QueryHookOptions<GetPlaybookEventStatusCardQuery, GetPlaybookEventStatusCardQueryVariables> & ({ variables: GetPlaybookEventStatusCardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlaybookEventStatusCardQuery, GetPlaybookEventStatusCardQueryVariables>(GetPlaybookEventStatusCardDocument, options);
      }
export function useGetPlaybookEventStatusCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlaybookEventStatusCardQuery, GetPlaybookEventStatusCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlaybookEventStatusCardQuery, GetPlaybookEventStatusCardQueryVariables>(GetPlaybookEventStatusCardDocument, options);
        }
export function useGetPlaybookEventStatusCardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlaybookEventStatusCardQuery, GetPlaybookEventStatusCardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlaybookEventStatusCardQuery, GetPlaybookEventStatusCardQueryVariables>(GetPlaybookEventStatusCardDocument, options);
        }
export type GetPlaybookEventStatusCardQueryHookResult = ReturnType<typeof useGetPlaybookEventStatusCardQuery>;
export type GetPlaybookEventStatusCardLazyQueryHookResult = ReturnType<typeof useGetPlaybookEventStatusCardLazyQuery>;
export type GetPlaybookEventStatusCardSuspenseQueryHookResult = ReturnType<typeof useGetPlaybookEventStatusCardSuspenseQuery>;
export type GetPlaybookEventStatusCardQueryResult = Apollo.QueryResult<GetPlaybookEventStatusCardQuery, GetPlaybookEventStatusCardQueryVariables>;
export const GetPlaybookEventInputCardDocument = gql`
    query getPlaybookEventInputCard($eventId: Long!) {
  playbook {
    event(eventId: $eventId) {
      inputs {
        id
        label
        workflowField
        resources {
          ...EventResources
        }
      }
    }
  }
}
    ${EventResourcesFragmentDoc}`;

/**
 * __useGetPlaybookEventInputCardQuery__
 *
 * To run a query within a React component, call `useGetPlaybookEventInputCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaybookEventInputCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaybookEventInputCardQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetPlaybookEventInputCardQuery(baseOptions: Apollo.QueryHookOptions<GetPlaybookEventInputCardQuery, GetPlaybookEventInputCardQueryVariables> & ({ variables: GetPlaybookEventInputCardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlaybookEventInputCardQuery, GetPlaybookEventInputCardQueryVariables>(GetPlaybookEventInputCardDocument, options);
      }
export function useGetPlaybookEventInputCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlaybookEventInputCardQuery, GetPlaybookEventInputCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlaybookEventInputCardQuery, GetPlaybookEventInputCardQueryVariables>(GetPlaybookEventInputCardDocument, options);
        }
export function useGetPlaybookEventInputCardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlaybookEventInputCardQuery, GetPlaybookEventInputCardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlaybookEventInputCardQuery, GetPlaybookEventInputCardQueryVariables>(GetPlaybookEventInputCardDocument, options);
        }
export type GetPlaybookEventInputCardQueryHookResult = ReturnType<typeof useGetPlaybookEventInputCardQuery>;
export type GetPlaybookEventInputCardLazyQueryHookResult = ReturnType<typeof useGetPlaybookEventInputCardLazyQuery>;
export type GetPlaybookEventInputCardSuspenseQueryHookResult = ReturnType<typeof useGetPlaybookEventInputCardSuspenseQuery>;
export type GetPlaybookEventInputCardQueryResult = Apollo.QueryResult<GetPlaybookEventInputCardQuery, GetPlaybookEventInputCardQueryVariables>;
export const GetPlaybookEventOutputsCardDocument = gql`
    query getPlaybookEventOutputsCard($eventId: Long!) {
  playbook {
    event(eventId: $eventId) {
      results {
        ...EventResources
      }
    }
  }
}
    ${EventResourcesFragmentDoc}`;

/**
 * __useGetPlaybookEventOutputsCardQuery__
 *
 * To run a query within a React component, call `useGetPlaybookEventOutputsCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaybookEventOutputsCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaybookEventOutputsCardQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetPlaybookEventOutputsCardQuery(baseOptions: Apollo.QueryHookOptions<GetPlaybookEventOutputsCardQuery, GetPlaybookEventOutputsCardQueryVariables> & ({ variables: GetPlaybookEventOutputsCardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlaybookEventOutputsCardQuery, GetPlaybookEventOutputsCardQueryVariables>(GetPlaybookEventOutputsCardDocument, options);
      }
export function useGetPlaybookEventOutputsCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlaybookEventOutputsCardQuery, GetPlaybookEventOutputsCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlaybookEventOutputsCardQuery, GetPlaybookEventOutputsCardQueryVariables>(GetPlaybookEventOutputsCardDocument, options);
        }
export function useGetPlaybookEventOutputsCardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlaybookEventOutputsCardQuery, GetPlaybookEventOutputsCardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlaybookEventOutputsCardQuery, GetPlaybookEventOutputsCardQueryVariables>(GetPlaybookEventOutputsCardDocument, options);
        }
export type GetPlaybookEventOutputsCardQueryHookResult = ReturnType<typeof useGetPlaybookEventOutputsCardQuery>;
export type GetPlaybookEventOutputsCardLazyQueryHookResult = ReturnType<typeof useGetPlaybookEventOutputsCardLazyQuery>;
export type GetPlaybookEventOutputsCardSuspenseQueryHookResult = ReturnType<typeof useGetPlaybookEventOutputsCardSuspenseQuery>;
export type GetPlaybookEventOutputsCardQueryResult = Apollo.QueryResult<GetPlaybookEventOutputsCardQuery, GetPlaybookEventOutputsCardQueryVariables>;
export const GetPlaybookEventErrorsCardDocument = gql`
    query getPlaybookEventErrorsCard($eventId: Long!) {
  playbook {
    event(eventId: $eventId) {
      getErrors
    }
  }
}
    `;

/**
 * __useGetPlaybookEventErrorsCardQuery__
 *
 * To run a query within a React component, call `useGetPlaybookEventErrorsCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaybookEventErrorsCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaybookEventErrorsCardQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetPlaybookEventErrorsCardQuery(baseOptions: Apollo.QueryHookOptions<GetPlaybookEventErrorsCardQuery, GetPlaybookEventErrorsCardQueryVariables> & ({ variables: GetPlaybookEventErrorsCardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlaybookEventErrorsCardQuery, GetPlaybookEventErrorsCardQueryVariables>(GetPlaybookEventErrorsCardDocument, options);
      }
export function useGetPlaybookEventErrorsCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlaybookEventErrorsCardQuery, GetPlaybookEventErrorsCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlaybookEventErrorsCardQuery, GetPlaybookEventErrorsCardQueryVariables>(GetPlaybookEventErrorsCardDocument, options);
        }
export function useGetPlaybookEventErrorsCardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlaybookEventErrorsCardQuery, GetPlaybookEventErrorsCardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlaybookEventErrorsCardQuery, GetPlaybookEventErrorsCardQueryVariables>(GetPlaybookEventErrorsCardDocument, options);
        }
export type GetPlaybookEventErrorsCardQueryHookResult = ReturnType<typeof useGetPlaybookEventErrorsCardQuery>;
export type GetPlaybookEventErrorsCardLazyQueryHookResult = ReturnType<typeof useGetPlaybookEventErrorsCardLazyQuery>;
export type GetPlaybookEventErrorsCardSuspenseQueryHookResult = ReturnType<typeof useGetPlaybookEventErrorsCardSuspenseQuery>;
export type GetPlaybookEventErrorsCardQueryResult = Apollo.QueryResult<GetPlaybookEventErrorsCardQuery, GetPlaybookEventErrorsCardQueryVariables>;
export const GetPlaybookEventEditableFieldsDocument = gql`
    query getPlaybookEventEditableFields($eventId: Long!) {
  playbook {
    event(eventId: $eventId) {
      id
      owner {
        username
      }
      alias
      note
    }
  }
}
    `;

/**
 * __useGetPlaybookEventEditableFieldsQuery__
 *
 * To run a query within a React component, call `useGetPlaybookEventEditableFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaybookEventEditableFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaybookEventEditableFieldsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetPlaybookEventEditableFieldsQuery(baseOptions: Apollo.QueryHookOptions<GetPlaybookEventEditableFieldsQuery, GetPlaybookEventEditableFieldsQueryVariables> & ({ variables: GetPlaybookEventEditableFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlaybookEventEditableFieldsQuery, GetPlaybookEventEditableFieldsQueryVariables>(GetPlaybookEventEditableFieldsDocument, options);
      }
export function useGetPlaybookEventEditableFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlaybookEventEditableFieldsQuery, GetPlaybookEventEditableFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlaybookEventEditableFieldsQuery, GetPlaybookEventEditableFieldsQueryVariables>(GetPlaybookEventEditableFieldsDocument, options);
        }
export function useGetPlaybookEventEditableFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlaybookEventEditableFieldsQuery, GetPlaybookEventEditableFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlaybookEventEditableFieldsQuery, GetPlaybookEventEditableFieldsQueryVariables>(GetPlaybookEventEditableFieldsDocument, options);
        }
export type GetPlaybookEventEditableFieldsQueryHookResult = ReturnType<typeof useGetPlaybookEventEditableFieldsQuery>;
export type GetPlaybookEventEditableFieldsLazyQueryHookResult = ReturnType<typeof useGetPlaybookEventEditableFieldsLazyQuery>;
export type GetPlaybookEventEditableFieldsSuspenseQueryHookResult = ReturnType<typeof useGetPlaybookEventEditableFieldsSuspenseQuery>;
export type GetPlaybookEventEditableFieldsQueryResult = Apollo.QueryResult<GetPlaybookEventEditableFieldsQuery, GetPlaybookEventEditableFieldsQueryVariables>;
export const UpdatePlaybookEventGridOnStatusChangeDocument = gql`
    query updatePlaybookEventGridOnStatusChange($eventId: Long!) {
  playbook {
    event(eventId: $eventId) {
      id
      status
      results {
        resourceType
      }
    }
  }
}
    `;

/**
 * __useUpdatePlaybookEventGridOnStatusChangeQuery__
 *
 * To run a query within a React component, call `useUpdatePlaybookEventGridOnStatusChangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlaybookEventGridOnStatusChangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatePlaybookEventGridOnStatusChangeQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useUpdatePlaybookEventGridOnStatusChangeQuery(baseOptions: Apollo.QueryHookOptions<UpdatePlaybookEventGridOnStatusChangeQuery, UpdatePlaybookEventGridOnStatusChangeQueryVariables> & ({ variables: UpdatePlaybookEventGridOnStatusChangeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpdatePlaybookEventGridOnStatusChangeQuery, UpdatePlaybookEventGridOnStatusChangeQueryVariables>(UpdatePlaybookEventGridOnStatusChangeDocument, options);
      }
export function useUpdatePlaybookEventGridOnStatusChangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpdatePlaybookEventGridOnStatusChangeQuery, UpdatePlaybookEventGridOnStatusChangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpdatePlaybookEventGridOnStatusChangeQuery, UpdatePlaybookEventGridOnStatusChangeQueryVariables>(UpdatePlaybookEventGridOnStatusChangeDocument, options);
        }
export function useUpdatePlaybookEventGridOnStatusChangeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UpdatePlaybookEventGridOnStatusChangeQuery, UpdatePlaybookEventGridOnStatusChangeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UpdatePlaybookEventGridOnStatusChangeQuery, UpdatePlaybookEventGridOnStatusChangeQueryVariables>(UpdatePlaybookEventGridOnStatusChangeDocument, options);
        }
export type UpdatePlaybookEventGridOnStatusChangeQueryHookResult = ReturnType<typeof useUpdatePlaybookEventGridOnStatusChangeQuery>;
export type UpdatePlaybookEventGridOnStatusChangeLazyQueryHookResult = ReturnType<typeof useUpdatePlaybookEventGridOnStatusChangeLazyQuery>;
export type UpdatePlaybookEventGridOnStatusChangeSuspenseQueryHookResult = ReturnType<typeof useUpdatePlaybookEventGridOnStatusChangeSuspenseQuery>;
export type UpdatePlaybookEventGridOnStatusChangeQueryResult = Apollo.QueryResult<UpdatePlaybookEventGridOnStatusChangeQuery, UpdatePlaybookEventGridOnStatusChangeQueryVariables>;